/** Link Mercado whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { linkmercDefaultTheme } from './default';

export { linkmercWhitelabel } from './default';

export const linkmercWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: linkmercDefaultTheme,
  },
};
